import { render } from "./FacultyComplianceChecked.vue?vue&type=template&id=f4906d10"
import script from "./FacultyComplianceChecked.vue?vue&type=script&lang=js"
export * from "./FacultyComplianceChecked.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__